import React, { useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router'
import { useAtomValue, useSetAtom } from 'jotai'

import {
	PageTitle, PostbackSendForm
} from '../components'
import * as lib from '../lib'
import * as state from '../states'
import { ERoleAccess } from '../types'
import { MENU, MENU_CATEGORY } from '../constants'
import { Access } from '../lib'
import { useTranslation } from 'react-i18next'

export const PostbackSendPage = (): React.JSX.Element => {
	const { t } = useTranslation()
	// const setFetchIsCommonToReload = useSetAtom(state.fetchIsCommonToReloadAtom)
	// const tokens = useAtomValue(state.tokensAtom)
	// const access = tokens?.access ?? null
	// const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)
	//
	// const profile = useAtomValue(state.profileAtom)
	// const $access = new Access(profile ?? null)

	const pageTitle = `${t(MENU_CATEGORY.affiliate.title)} ${t(MENU.postbackSend.title)}`

	// TODO: check the logic
	return (
		<>
			<PageTitle title={pageTitle}/>

			<div className="card rounded-3 border-0 mb-24">
				<div className="card-body p-25">
					{/*<div className="d-flex align-items-center justify-content-between pb-20 border-bottom border-color">
						Test PostbackSend Page ...
					</div>*/}

					<PostbackSendForm/>
				</div>
			</div>
		</>
	)
}
